import React from 'react';

import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';

import { NoIssuesFoundInfoStyled, Text } from './NoIssuesFoundInfo.styled';

export const NoIssuesFoundInfo = () => {
  return (
    <NoIssuesFoundInfoStyled>
      <EditorPanelIcon />
      <Text>We couldn’t find issues matching your search</Text>
    </NoIssuesFoundInfoStyled>
  );
};
